import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/campaign-analytics")({
  component: lazyRouteComponent(() => import("./-pages/admin.campaign-analytics")),
  head: () => ({
    meta: [
      { title: "Campaign Analytics · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
